import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-628b356e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = { class: "bottom" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Мемасик", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, "Легкий и позитивный веб-сериал о жизни 13-летнего Мирона и его отношениях с мамой.", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "category" }, "Сериал | 8 серий | реалити | 8+", -1))
const _hoisted_7 = { class: "actions" }
const _hoisted_8 = { class: "right" }

import BaseButton from '@/components/Buttons/BaseButton.vue'
import CircleButton from '@/components/Buttons/CircleButton.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'DetailTest',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BaseButton, {
        class: "uppercase",
        bg: "none",
        border: "default"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Серия 1")
        ]),
        _: 1
      }),
      _createVNode(BaseButton, {
        class: "uppercase",
        bg: "none",
        border: "default"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Серия 2")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(CircleButton, {
          name: "like",
          iconWidth: 18,
          iconHeight: 15.96,
          "view-box": "0 0 18 15.96"
        }),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(CircleButton, {
            name: "mute",
            bg: "none",
            iconWidth: 16,
            iconHeight: 18,
            "view-box": "0 0 16 18"
          }),
          _createVNode(CircleButton, {
            name: "profile",
            iconWidth: 16,
            iconHeight: 18,
            "view-box": "0 0 16 18"
          }),
          _createVNode(CircleButton, {
            name: "chevron-down",
            iconWidth: 15,
            iconHeight: 30,
            "view-box": "0 0 15 30"
          })
        ])
      ])
    ])
  ]))
}
}

})